import React, { useState } from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { _t } from 'utils';

export default ({ item = {}, dcId }) => {
  const [isPublic, setIsPublic] = useState(true);
  const { id, ...editProps } = item;

  const model = {
    name: '',
    ips: [],
    ...editProps,
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'listenerLan',
      type: 'lan',
      title: 'Listener Lan',
      hasNewOption: false,
      onPublicChange: (e) => setIsPublic(e),
    },
    {
      name: 'ips',
      type: 'ips',
      title: 'IPs',
    },
    {
      name: 'targetLan',
      type: 'lan',
      title: 'Target Lan',
      hasNewOption: false,
      privateOnly: true,
    },
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'ips', type: VALIDATION.REQUIRED },
    { name: 'listenerLan', type: VALIDATION.REQUIRED },
    { name: 'targetLan', type: VALIDATION.REQUIRED },
  ];

  const onSave = (properties) => {
    if (properties?.listenerLan === properties?.targetLan) return alert('The listener LAN & target LAN should be different!');
    if (id) return actions.networkLoadbalancer.update({ dcId, id, properties });
    return actions.networkLoadbalancer.create({ dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
      changeFields={[
        { name: 'ips', props: { privateOnly: !isPublic } },
      ]}
    />
  );
};
